import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useNavigate } from "react-router-dom";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { tasksId } from "../../../types/activityTasks";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { PanelInstrucionHands } from "../../../components/common/PanelInstrucionHands";
import { imgInstruction } from "../../../assets/imgIntruction";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	initialDialog: 1,
	dialogTwo: 2,
	dialogTwoExtra: 30,
	instructions: 3,
	instructions2: 21,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
	dialogEight: 9,
	dialogNine: 10,
	dialogTen: 11,
	dialogEleven: 12,
	dialogTwelve: 13,
	viewActivities: 20,
};

export const SubtopicFourActivityOne = () => {
	const navigator = useNavigate();
	const dispatch = useDispatch();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(steps.initialDialog);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema1.activities.subtema4], 1);

	useEffect(() => {
		if (loaded) {
			console.log("subtema 4 Activity one");
			ObserverEmitter.emit(EVENTS.subtopicFour.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub04.sub4_act1_a01)
	})

	ObserverEmitter.on(EVENTS.subtopicFour.activityOne.clickonTiket, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub04.sub4_act1_a10)
		setUiToShow(steps.dialogTen);
	});

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.subtopicFour.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>
			{steps.initialDialog === uiToShow && (
				<>
					<HeaderRedPresentation name="Actividad 1: Etiqueteo." />
					<DialogBarNew
						titulo="Datti Andatti"
						percentage={"10%"}
						dialog={"Ahora debemos revisar que las etiquetas de los productos se encuentren en buen estado y actualizadas."}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.viewActivities);
						}}
					></DialogBarNew>
				</>
			)}
			{steps.viewActivities === uiToShow && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 4: Etiquetado."
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub04.sub4_act1_a02)
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{steps.dialogTwo === uiToShow && (
				<>
					<HeaderRedPresentation name="Actividad 1: Etiqueteo." />
					<DialogBarNew
						titulo="Datti Andatti"
						percentage={"20%"}
						dialog={"En caso de encontrar alguna etiqueta en mal estado o desactualizada debes cambiarla."}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub04.sub4_act1_a03)
							setUiToShow(steps.dialogTwoExtra);
						}}
					></DialogBarNew>
				</>
			)}

			{steps.dialogTwoExtra === uiToShow && (
				<>
					<HeaderRedPresentation name="Actividad 1: Etiqueteo." />
					<DialogBarNew
						titulo="Datti Andatti"
						percentage={"20%"}
						dialog={"Es momento de realizar el etiquetado. Observa cuidadosamente la góndola e identifica las etiquetas que deben ser cambiadas."}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.instructions);
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							ObserverEmitter.emit(EVENTS.subtopicFour.activityOne.moveZoom);
						}}
					></DialogBarNew>
				</>
			)}

			{steps.instructions === uiToShow && (
				<PanelInstrucionHands
					text="Toca encima de la etiqueta en mal estado para cambiarla."
					action={() => {
						setUiToShow(steps.instructions2);
					}}
					img={imgInstruction.sub4_act_1_01}
				/>
			)}
			{steps.instructions2 === uiToShow && (
				<PanelInstrucionHands
					text="Toca encima para seleccionar en el hanheld la opción correcta."
					action={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub04.sub4_act1_a04)
						setUiToShow(steps.dialogFour);
						ObserverEmitter.emit(EVENTS.subtopicFour.activityOne.visibleHandler);
					}}
					img={imgInstruction.sub4_act_1_02}
				/>
			)}
			{/* {steps.dialogThree === uiToShow && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						percentage={"30%"}
						dialog={"Selecciona la etiqueta que se encuentra en mal estado y retírala de la góndola."}
						whitImg={true}
						callback={() => {
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)} */}
			{steps.dialogFour === uiToShow && (
				<>
					<BarStatusActivies activities={tasksList} />
					<DialogBarNew
						titulo="Datti Andatti"
						percentage={"40%"}
						dialog={"Selecciona en la handheld la opción de Procesos."}
						whitImg={true}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub04.sub4_act1_a05)
							ObserverEmitter.emit(EVENTS.subtopicFour.activityOne.clicktoscreen3);
							setUiToShow(steps.dialogFive);
						}}
					></DialogBarNew>
				</>
			)}
			{steps.dialogFive === uiToShow && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						percentage={"50%"}
						dialog={"Luego la opción de etiqueteo"}
						whitImg={true}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub04.sub4_act1_a06)
							ObserverEmitter.emit(EVENTS.subtopicFour.activityOne.clicktoscreen4);
							setUiToShow(steps.dialogSix);
						}}
					></DialogBarNew>
				</>
			)}
			{steps.dialogSix === uiToShow && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						percentage={"60%"}
						dialog={"Recuerda el papel para etiquetas en la impresora."}
						whitImg={true}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub04.sub4_act1_a07)
							ObserverEmitter.emit(EVENTS.subtopicFour.activityOne.clicktoscreen5);
							setUiToShow(steps.dialogSeven);
						}}
					></DialogBarNew>
				</>
			)}
			{steps.dialogSeven === uiToShow && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						percentage={"70%"}
						dialog={"Es momento de escanear uno de los artículos, selecciona una de ellas"}
						whitImg={true}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub04.sub4_act1_a08)
							ObserverEmitter.emit(EVENTS.subtopicFour.activityOne.clicktoscreen6);
							setUiToShow(steps.dialogEight);
						}}
					></DialogBarNew>
				</>
			)}
			{steps.dialogEight === uiToShow && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						percentage={"80%"}
						dialog={"Bien, selecciona la opción de imprimir y pasemos a la impresora"}
						whitImg={true}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub04.sub4_act1_a09)
							setUiToShow(steps.dialogNine);
							ObserverEmitter.emit(EVENTS.subtopicFour.activityOne.hiddenHandler);
							ObserverEmitter.emit(EVENTS.subtopicFour.activityOne.moveToTicket);
						}}
					></DialogBarNew>
				</>
			)}
			{steps.dialogNine === uiToShow && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						percentage={"90%"}
						dialog={"Es hora de recoger la etiqueta y ponerla donde corresponde, ¡vamos!"}
						whitImg={true}
						callback={() => { }}
					></DialogBarNew>
				</>
			)}
			{steps.dialogTen === uiToShow && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						percentage={"90%"}
						dialog={"Coloca la nueva etiqueta en el espacio vacío."}
						whitImg={true}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.festejo);
							setUiToShow(steps.dialogTwelve);
						}}
					></DialogBarNew>
				</>
			)}
			{/* {steps.dialogEleven === uiToShow && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						percentage={"90%"}
						dialog={"¡Tu puedes! Se cuidadoso al verificar que cada etiqueta debe estar en buen estado, acutualizada y colocada."}
						whitImg={true}
						callback={() => {
							setUiToShow(steps.dialogTwelve);
						}}
					></DialogBarNew>
				</>
			)} */}
			{steps.dialogTwelve === uiToShow && (
				<ValidationResultModal
					title="¡Bien hecho!"
					dialogModal="Mantener tus etiquetas actualizadas y en buen estado es fundamental para tu Tienda."
					buttonTxt="Continuar"
					isCorrect={true}
					action={() => {
						dispatch(
							completeOneTask({
								idActivity: 1,
								pointsWin: 0,
								subtema: tasksId.tema1.activities.subtema4,
							})
						);
						navigator("/home1/tema1/subtema4/activitytwo");
					}}
				/>
			)}
		</>
	);
};
